import { FieldType } from '@ngx-formly/material';

import { Component } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { ISnCheckboxFormFieldConfig } from '../../interfaces/checkbox-form-field-config.interface';
import { ISnMulticheckboxOption } from '../../interfaces/checkbox-option.interface';
import {
  ISnCheckboxTemplateOptions,
  ISnCheckboxGroupTemplateOptions,
} from '../../interfaces/checkbox-template-options.interface';
import { SnCheckboxValue } from '../../types/checkbox-value.type';

@Component({
  selector: 'sn-checkbox-form-field',
  templateUrl: './checkbox.form-field.html',
  styleUrls: ['./checkbox.form-field.scss'],
})
export class SnCheckboxFormField extends FieldType<ISnCheckboxFormFieldConfig> {
  public readonly defaultOptions: ISnCheckboxFormFieldConfig = {
    type: 'checkbox',
    templateOptions: {
      floatLabel: 'always',
      hideLabel: true,
      appearance: 'fill',
      color: 'accent',
      hideFieldUnderline: true,
    },
  };

  constructor(private readonly _sanitizer: DomSanitizer) {
    super();
  }

  get templateOptions(): ISnCheckboxTemplateOptions | ISnCheckboxGroupTemplateOptions {
    return this.field.templateOptions;
  }

  public trackOption(index: number, item: { label: string; value: any }): any {
    return item.value;
  }

  public isChecked({ value }: ISnMulticheckboxOption): boolean {
    const controlValue = this.formControl.value;

    return controlValue && controlValue.includes(value);
  }

  public onChange(option: ISnMulticheckboxOption, checked: boolean): void {
    const previousValue = this.formControl.value ? [...this.formControl.value] : [];
    const currentValue: SnCheckboxValue[] = [];

    if (checked) {
      currentValue.push(...previousValue, option.value);
    } else if (previousValue) {
      currentValue.push(...previousValue.filter((value) => value !== option.value));
    }

    this.formControl.patchValue(currentValue);
    this.templateOptions.change(this.field, currentValue);
    this.formControl.markAsTouched();
  }

  public safeHTML(value: any): SafeHtml {
    return this._sanitizer.bypassSecurityTrustHtml(value);
  }
}
